"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMeshName = exports.groupDataPipelineMeshes = exports.getFirstExplicitMeshName = void 0;
const getFirstExplicitMeshName = ({ artifactIds, getArtifactMetadata, }) => {
    for (const artifactId of artifactIds) {
        const meshName = getArtifactMetadata(artifactId).explicitMeshName;
        if (meshName) {
            return meshName;
        }
    }
    return null;
};
exports.getFirstExplicitMeshName = getFirstExplicitMeshName;
const hasAmbiguousExplicitMeshNames = ({ artifactIds, getArtifactMetadata, }) => {
    const explicitMeshNames = new Set();
    artifactIds.forEach((artifactId) => {
        const meshName = getArtifactMetadata(artifactId).explicitMeshName;
        if (meshName) {
            explicitMeshNames.add(meshName);
        }
    });
    return explicitMeshNames.size > 1;
};
const groupDataPipelineMeshes = ({ connectedGraphs, getArtifactMetadata, }) => {
    let hasAmbiguousMeshNames = false;
    const disconnectedGraphs = connectedGraphs.filter((graph) => graph.some((artifactId) => getArtifactMetadata(artifactId).hasUploadConfig));
    const meshGroups = disconnectedGraphs.reduce((acc, artifactIds, index) => {
        hasAmbiguousMeshNames =
            hasAmbiguousMeshNames ||
                hasAmbiguousExplicitMeshNames({
                    artifactIds,
                    getArtifactMetadata,
                });
        const uniqueMeshName = (0, exports.getFirstExplicitMeshName)({
            artifactIds,
            getArtifactMetadata,
        }) ?? `mesh#${index}`;
        const meshGroup = acc.get(uniqueMeshName) || [];
        meshGroup.push(artifactIds);
        acc.set(uniqueMeshName, meshGroup);
        return acc;
    }, new Map());
    return {
        meshes: Array.from(meshGroups.values()).map((meshes) => meshes.flat()),
        hasAmbiguousMeshNames,
    };
};
exports.groupDataPipelineMeshes = groupDataPipelineMeshes;
const makeMeshName = ({ explicitMeshName, cfSlugs, cfSlugToNameMap, }) => {
    if (explicitMeshName) {
        return explicitMeshName;
    }
    const cfNames = cfSlugs.flatMap((cfSlug) => {
        const cfName = cfSlugToNameMap.get(cfSlug);
        return cfName ? [cfName] : [];
    });
    // Sort so the joined name is deterministic regardless of the order in which
    // cfSlugs were gathered. Different call sites (full-graph traversal vs the
    // lightweight metadata path) iterate a mesh's artifacts in different orders,
    // and without sorting a multi-credit-facility mesh would get an
    // order-dependent (and cross-path-divergent) name.
    return [...cfNames].sort().join(', ') || 'Missing Mesh Name';
};
exports.makeMeshName = makeMeshName;
//# sourceMappingURL=meshGrouping.js.map